import Toast from 'react-native-toast-message';

/**
 * Global Toast Utility (ported from SK Catalog's components/toastComponent.tsx).
 * Standardized interface for triggering temporary notification overlays app-wide.
 * Everything (useToast, showSuccess, handleApiError) funnels through here.
 */
export const showToast = (type: 'success' | 'error' | 'info', text1: string, text2?: string) => {
  Toast.show({
    type,
    text1,
    text2,
    // Success/info: 3s — enough to read a short confirmation.
    // Error: 4s — backend messages can be multi-sentence.
    visibilityTime: type === 'error' ? 4000 : 3000,
    autoHide: true,
    topOffset: 60,
    // Allow long backend messages (validation/conflict details) to wrap.
    ...(text2 ? ({ text2NumberOfLines: 5 } as any) : {}),
  });
};
